export default "__VITE_ASSET__COJGIYsZ__"